export default __webpack_public_path__ + "static/media/movie5.1c60d326.png";